import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCheckboxUnactiveIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path fill="none" d="M0 0h20v20H0z" />
    <rect
      width={18}
      height={18}
      x={1}
      y={1}
      stroke="#605DEC"
      strokeWidth={2}
      rx={3}
    />
  </svg>
);
export default SvgCheckboxUnactiveIcon;
